import { render } from "./SongRequestCard.vue?vue&type=template&id=15aeba10&scoped=true"
import script from "./SongRequestCard.vue?vue&type=script&scoped=true&lang=js"
export * from "./SongRequestCard.vue?vue&type=script&scoped=true&lang=js"

import "./SongRequestCard.vue?vue&type=style&index=0&id=15aeba10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aeba10"]])

export default __exports__